import ApiService from "./api.service";

export const Offers = {
  getOffers: async function (constructionId) {
    let response = await ApiService.get("construction/" + constructionId + "/offers");
    return response.data
  },
  addOffer: async function (content) {
    let response = await ApiService.post("construction/" + content.construction_id + "/offer", content.query);
    return response.data;
  },
  editOffer: async function (content) {
    let response = await ApiService.patch("construction/" + content.construction_id + "/offer/" + content.offer_id, content.query);
    return response.data;
  },
  getOffert: async function (query) {
    let response = await ApiService.get("construction/" + query.constructionId + "/offer/" + query.offerId);
    return response.data;
  },
  offerRemove: async function (query) {
    let response = await ApiService.delete("construction/" + query.constructionId + "/offer/" + query.offerId);
    return response.data;
  },
  download: async function (content) {
    return await ApiService.customRequest({
      method: "get",
      url: "construction/" + content.constructionId + "/offer/" + content.offerId+"/pdf",
      responseType: "blob",
    });
  },
};

export default {
  Offers
};